var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.9578C5.05817 18.9578 1.0415 14.9412 1.0415 9.99949C1.0415 5.05782 5.05817 1.04115 9.99984 1.04115C14.9415 1.04115 18.9582 5.05782 18.9582 9.99949C18.9582 14.9412 14.9415 18.9578 9.99984 18.9578ZM9.99984 2.29115C5.74984 2.29115 2.2915 5.74949 2.2915 9.99949C2.2915 14.2495 5.74984 17.7078 9.99984 17.7078C14.2498 17.7078 17.7082 14.2495 17.7082 9.99949C17.7082 5.74949 14.2498 2.29115 9.99984 2.29115Z",
    fill: "#F52929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4578C9.65833 11.4578 9.375 11.1745 9.375 10.8328V6.66615C9.375 6.32449 9.65833 6.04115 10 6.04115C10.3417 6.04115 10.625 6.32449 10.625 6.66615V10.8328C10.625 11.1745 10.3417 11.4578 10 11.4578Z",
    fill: "#F52929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.1661C9.8915 14.1661 9.78317 14.1411 9.68317 14.0995C9.58317 14.0578 9.4915 13.9995 9.40817 13.9245C9.33317 13.8411 9.27484 13.7578 9.23317 13.6495C9.1915 13.5495 9.1665 13.4411 9.1665 13.3328C9.1665 13.2245 9.1915 13.1161 9.23317 13.0161C9.27484 12.9161 9.33317 12.8245 9.40817 12.7411C9.4915 12.6661 9.58317 12.6078 9.68317 12.5661C9.88317 12.4828 10.1165 12.4828 10.3165 12.5661C10.4165 12.6078 10.5082 12.6661 10.5915 12.7411C10.6665 12.8245 10.7248 12.9161 10.7665 13.0161C10.8082 13.1161 10.8332 13.2245 10.8332 13.3328C10.8332 13.4411 10.8082 13.5495 10.7665 13.6495C10.7248 13.7578 10.6665 13.8411 10.5915 13.9245C10.5082 13.9995 10.4165 14.0578 10.3165 14.0995C10.2165 14.1411 10.1082 14.1661 9.99984 14.1661Z",
    fill: "#F52929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.7f802aa9cdc353148b7dbd36724e7925.svg";
export { ForwardRef as ReactComponent };